'use client';

import React from 'react';
import styles from './SettingTab.module.scss';

interface SettingToggleProps {
  icon?: React.ReactNode;
  text: string;
  isChecked: boolean;
  onChange: () => void;
}

/**
 * Toggle switch component for settings with an icon and text
 */
const SettingToggle: React.FC<SettingToggleProps> = ({
  icon,
  text,
  isChecked,
  onChange
}) => {
  return (
    <div className={styles.settingToggle}>
      <div className={styles.iconWrapper}>
        {icon}
      </div>
      <span className={styles.settingText}>{text}</span>
      <label className={styles.toggleSwitch}>
        <input type="checkbox" checked={isChecked} onChange={onChange} />
        <span className={styles.toggleSlider}></span>
      </label>
    </div>
  );
};

export default SettingToggle;
